import React from 'react';
import { useAppSelector } from '@breakroom-nx/redux';

// Modalized Components
import {
  Randomizer,
  AccountConversion,
  InviteFriendToApp,
  UserInviteList,
  Search,
  Alert,
  CreateChat,
  PermissionsContainer,
  ProfileSetup,
  AccountDeletion,
  Enable2FA,
  Validate2FACodeView,
  NoRoomsFound,
  ChangePassword,
  Report,
  NotificationAlert,
} from '../../';

export const ModalManager = () => {
  const modalLookup = {
    Search,
    Alert,
    InviteFriendToApp,
    UserInviteList,
    Randomizer,
    AccountConversion,
    CreateChat,
    PermissionsContainer,
    ProfileSetup,
    AccountDeletion,
    Enable2FA,
    Validate2FACodeView,
    NoRoomsFound,
    ChangePassword,
    Report,
    NotificationAlert,
  };

  const currentModal = useAppSelector((state) => state.modal.value);
  let renderedModal;
  if (currentModal) {
    const { modalType, modalProps } = currentModal;
    // console.log();

    const ModalComponent = modalLookup[modalType];
    renderedModal = <ModalComponent {...modalProps} />;
  }

  return (
    <>
      {renderedModal}
      {/* {console.log(renderedModal)} */}
    </>
  );
};
